import React from "react";
import { FormField } from "../../UI/DesignStandards";
import { formatPair, pairStartFromLane } from "../../../utility/laneAssignment";

export const LaneAssignmentFields = ({
  startingPair,
  onStartingPairChange,
}) => {
  const pairHint = formatPair(pairStartFromLane(startingPair));

  return (
    <div className="space-y-4">
      <h3 className="heading-display text-lg">Lane assignment</h3>
      <p className="text-sm text-brand-muted">Optional.</p>
      <FormField
        label="Starting lane"
        type="number"
        min="1"
        value={startingPair}
        onChange={(e) => onStartingPairChange(e.target.value)}
        placeholder="5"
      />
      {pairHint ? (
        <p className="text-sm text-brand-muted -mt-2">Pair {pairHint}</p>
      ) : null}
    </div>
  );
};
